export default "__VITE_ASSET__DH53QuJH__"